import * as ko from 'knockout';
import { Observable } from 'knockout';
import DualListBoxIconDetails from './dualListBoxIconDetails';

class DualListBoxItem {
  public isChecked: Observable<boolean>;
  public isSelected: Observable<boolean>;
  public isPersonaPreregistered: Observable<boolean>;

  // this empty function is workaround to handle bubbling to distinguish clicks
  // on parent container from clicks on the checkbox
  public emptyClickBubbleHandler = (): true => {
    return true;
  };

  constructor(
    public id: string,
    public name: string,
    isChecked: boolean,
    isPreRegistered: boolean,
    public iconDetails: DualListBoxIconDetails | null = null) {

    this.isChecked = ko.observable(isChecked);
    this.isSelected = ko.observable(false);
    this.isPersonaPreregistered = ko.observable(isPreRegistered);
  }
}
export default DualListBoxItem;
